import { SubPageBlueprint } from '@backstage/frontend-plugin-api';

/**
 * Criar › Execuções in the v2 design (Stories 5.1, 5.2, 2.3; AC-24): an
 * extension with the stock id `sub-page:scaffolder/tasks`, installed by the
 * scaffolder frontend module, so it replaces only the stock tasks sub-page.
 * The path stays `tasks` and the title stays configurable (app-config.yaml
 * sets "Execuções"); `page:scaffolder`, its other tabs, the header action
 * and the `.byx-scaffolder` wrapper are untouched.
 */
export const byxExecutionsSubPage = SubPageBlueprint.make({
  name: 'tasks',
  params: {
    path: 'tasks',
    title: 'Tasks',
    loader: () =>
      import('./ExecutionsRoutes').then(m => <m.ExecutionsRoutes />),
  },
});
